// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import iacEntity from './entities/iac.json';
import iacMenu from '../pages/iac/menu.json';
import iacFullForm from '../pages/iac/forms/full.json';
import iacContextForm from '../pages/iac/forms/context.json';
import iacMiniForm from '../pages/iac/forms/mini.json';
import iacLookupForm from '../pages/iac/forms/lookup.json';
import iacTableView from '../pages/iac/views/table.json';
import iacStagesView from '../pages/iac/views/stages.json';
import iacCardsView from '../pages/iac/views/cards.json';
import iacInlineView from '../pages/iac/views/inline.json';
import iacBacklogView from '../pages/iac/views/backlog.json';
import iacSplitView from '../pages/iac/views/split.json';
import iacCalendarView from '../pages/iac/views/calendar.json';
import iacDashboardView from '../pages/iac/views/dashboard.json';

/** Тип запису «Взаємодія» зі сторінками пакета: меню, форми та подання з pages/iac/. */
export const iacDefinition: IRecordTypeDefinition = {
  ...iacEntity,
  views: assembleViewSet({
      table: iacTableView,
      stages: iacStagesView,
      cards: iacCardsView,
      inline: iacInlineView,
      backlog: iacBacklogView,
      split: iacSplitView,
      calendar: iacCalendarView,
      dashboard: iacDashboardView,
  }),
  form: iacFullForm,
  forms: { full: iacFullForm, context: iacContextForm, mini: iacMiniForm, lookup: iacLookupForm },
  menu: iacMenu,
} as IRecordTypeDefinition;
